import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateAttendanceByLapsePDF = (data) => {
  const doc = new jsPDF({ orientation: 'portrait' });

  doc.setFontSize(16);
  doc.text('Reporte de Asistencia', 14, 10);
  let startY = 20;

  Object.keys(data).forEach((grade, gradeIndex) => {
    if (gradeIndex > 0) startY += 15;

    // Título del grado (solo color para el grado)
    doc.setFont(undefined, 'bold');
    doc.text(grade.toUpperCase(), 14, startY);
    doc.setFont(undefined, 'normal');
    startY += 12; // Espacio después del nombre del grado

    Object.keys(data[grade]).forEach((section, sectionIndex) => {
      // Espacio entre secciones
      if (sectionIndex > 0) startY += 10;

      // Sección (sin color específico)
      doc.setFontSize(12); // Tamaño de letra más pequeño para la sección
      doc.setFont(undefined, 'bold');
      doc.text(`Sección ${section}`, 14, startY);
      doc.setFont(undefined, 'normal');
      startY += 10; // Espacio después de la sección

      Object.keys(data[grade][section]).forEach((student, studentIndex) => {
        // Espacio extra entre estudiantes
        if (studentIndex > 0) startY += 7;

        // Nombre del estudiante (sin color específico)
        doc.setFontSize(11); // Tamaño de letra más pequeño para el nombre del estudiante
        doc.setFont(undefined, 'bold');
        doc.text(student, 14, startY);
        doc.setFont(undefined, 'normal');
        startY += 2; // Espacio extra después del nombre del estudiante

        // Tabla de asistencia del estudiante
        const headers = [['Materia', 'Asistencias', 'Inasistencias']];
        const body = Object.entries(data[grade][section][student].subjects).map(([subject, record]) => [
          subject,
          record.presences,
          record.absences,
        ]);

        autoTable(doc, {
          head: headers,
          body: body,
          startY,
          theme: 'grid',
          styles: { fontSize: 10 },
          headStyles: { fillColor: [200, 200, 200] },
          columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 40 }, 2: { cellWidth: 40 } },
        });

        startY = doc.lastAutoTable.finalY + 5; // Espacio después de la tabla
      });

      startY += 5; // Espacio adicional entre secciones
    });
  });

  doc.save('asistencia.pdf');
};



export const generateAttendanceBySubjectPDF = (data) => {
  const doc = new jsPDF({ orientation: 'portrait' });

  doc.setFontSize(16);
  doc.text('Reporte de Asistencia', 14, 10);
  let startY = 20;

  // Recorrer la estructura de datos
  Object.keys(data).forEach((subject) => {
    Object.keys(data[subject]).forEach((grade) => {
      if (startY > 20) startY += 15; // Espacio entre materias

      // Título de la materia y grado
      doc.setFont(undefined, 'bold');
      doc.text(`${subject} - ${grade}`, 14, startY);
      doc.setFont(undefined, 'normal');
      startY += 10; // Espacio después del título

      Object.keys(data[subject][grade]).forEach((section) => {
        if (startY > 30) startY += 10; // Espacio entre secciones

        // Título de la sección
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(`Sección ${section.charAt(0).toUpperCase() + section.slice(1)}`, 14, startY);
        doc.setFont(undefined, 'normal');
        startY += 3; // Espacio después de la sección

        // Crear tabla con los estudiantes
        const headers = [['Estudiante', 'Asistencias', 'Inasistencias']];
        const body = Object.keys(data[subject][grade][section]).map((student) => [
          student.charAt(0).toUpperCase() + student.slice(1),
          data[subject][grade][section][student].presences,
          data[subject][grade][section][student].absences,
        ]);

        // Generar la tabla
        autoTable(doc, {
          head: headers,
          body: body,
          startY,
          theme: 'grid',
          styles: { fontSize: 10 },
          headStyles: { fillColor: [200, 200, 200] },
          columnStyles: { 0: { cellWidth: 80 }, 1: { cellWidth: 40 }, 2: { cellWidth: 40 } },
        });

        startY = doc.lastAutoTable.finalY + 5; // Espacio después de la tabla
      });
    });
  });

  // Guardar el documento PDF
  doc.save('reporte_asistencia.pdf');
}